var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { buildFilterString } from "./ExpApiVUnified.utils.js";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
import { getUnifiedApiVersion } from "./ExpAPIVUnified.constants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let FeatureResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.expmanAdapter, "/workspaces/", parseError);
  }
  getFeatures(workspaceId, filters) {
    return __async(this, null, function* () {
      const filterString = buildFilterString(workspaceId, filters);
      const address = `${workspaceId}/features?api-version=${getUnifiedApiVersion()}${filterString ? `&${filterString}` : ""}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getFeature(workspaceId, featureId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/features/${featureId}?api-version=${getUnifiedApiVersion()}`;
      return yield this._get(address);
    });
  }
  createFeature(workspaceId, request) {
    return __async(this, null, function* () {
      const featureId = request.id || getNewGuid();
      const address = `${workspaceId}/features/${featureId}?api-version=${getUnifiedApiVersion()}`;
      return yield this._put(request, address);
    });
  }
  editFeatureRestResult(workspaceId, featureId, request) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/features/${featureId}?api-version=${getUnifiedApiVersion()}`;
      return yield this._put(request, address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting features.` })
], FeatureResource.prototype, "getFeatures", 1);
__decorateClass([
  onError({ message: `An error occured while getting feature.` })
], FeatureResource.prototype, "getFeature", 1);
__decorateClass([
  onError({ message: `An error occured while creating the feature.` })
], FeatureResource.prototype, "createFeature", 1);
__decorateClass([
  onError({ message: `An error occured while editing feature.` })
], FeatureResource.prototype, "editFeatureRestResult", 1);
FeatureResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], FeatureResource);
const FeatureResource$1 = new FeatureResource();
export {
  FeatureResource,
  FeatureResource$1 as default
};
//# sourceMappingURL=Feature.resource.js.map
